'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "edit-iframe-dialog" */'./EditIframeDialogContainer').then(module => module.EditIframeDialogContainer);
export default Loadable({
  loader,
  LoadingComponent: () => null
});